/**
 * Utilities untuk memformat nama pengguna Indonesia yang seringkali
 * memuat gelar akademik atau title religius seperti:
 *   "Pdt. Silwanus Werimon"
 *   "Pdp. Johan Oliever Wambrauw, S.Pd., MM"
 *   "Reno Rangga, ST., MT"
 *   "Dr. Ir. Bpk. Contoh, M.Th."
 *
 * `firstName()` mengembalikan nama panggilan pertama tanpa gelar prefix
 * (Pdt./Pdp./Bpk./Ibu./Dr./Prof./Ir./H./Hj./Sdr./Sdri./Ny./Tn./A.Md.)
 * dan tanpa gelar suffix (segala sesuatu setelah koma pertama).
 *
 * Contoh:
 *   firstName("Reno Rangga, ST., MT") === "Reno"
 *   firstName("Pdt. Silwanus Werimon") === "Silwanus"
 *   firstName("Pdp. Johan Oliever Wambrauw, S.Pd., MM") === "Johan"
 */

const TITLE_PREFIXES = [
  "pdt", "pdp", "pnt", "sy", "syamas",  // religius
  "bpk", "bapak", "ibu", "ny", "tn", "sdr", "sdri",  // sapaan
  "dr", "prof", "ir", "drs", "dra",  // akademik prefix
  "h", "hj", "kh", "kh.",  // religius Islam (rare here but safe)
  "a.md", "amd", "st", "se",  // occasionally used as prefix (rare)
];

function stripPrefixes(tokens) {
  // Iteratively remove leading tokens that look like a title (case-insensitive,
  // possibly with trailing dot(s)).
  const out = [...tokens];
  while (out.length > 1) {
    const raw = out[0].toLowerCase().replace(/\.+$/, "");
    if (TITLE_PREFIXES.includes(raw)) {
      out.shift();
    } else {
      break;
    }
  }
  return out;
}

export function firstName(full) {
  if (!full || typeof full !== "string") return "";
  // 1. Buang segala sesuatu setelah koma pertama (biasanya gelar suffix)
  const beforeComma = full.split(",")[0].trim();
  // 2. Split jadi tokens
  const tokens = beforeComma.split(/\s+/).filter(Boolean);
  if (!tokens.length) return "";
  // 3. Buang prefix gelar
  const clean = stripPrefixes(tokens);
  // 4. Ambil kata pertama
  return clean[0] || "";
}

export function fullNameNoTitles(full) {
  if (!full || typeof full !== "string") return "";
  const beforeComma = full.split(",")[0].trim();
  const tokens = beforeComma.split(/\s+/).filter(Boolean);
  const clean = stripPrefixes(tokens);
  return clean.join(" ");
}
